import React, { Fragment, useState } from 'react';

// Material UI
import { Paper, Typography, Box, Grid, Divider } from "@mui/material"

// Hooks
import useCashRegister from "../../../../hooks/cashRegisters/useCashRegister";

// Components
import ViewTotal from './modals';
import Info from "./totals/Info";
import Total from "./totals/Total";
// import Total from "../../../Archings/totals/Total";
import Spinner from '../../../../components/spinner';

//Services
import PaymentService from '../../../../services/paymentService';
import { cashTypes } from "../../../../models/CashRegisterMovementEntity";

const ClosedCard = ({ cardsTotals, onAccept, loadingCard, viewMovements, setDiffCard }) => {
    const { cashRegister } = useCashRegister();
    const [details, setDetails] = useState([]);
    const [viewTotalModalOpen, setViewTotalModalOpen] = useState(false);
    const [loadingDetails, setLoadingDetails] = useState(true);
    const [cardSelected, setdcarSelected] = useState(null);

    const handleSetViewTotal = async (cardSelected) => {
        setdcarSelected(cardSelected);
        setViewTotalModalOpen(true);
        setLoadingDetails(true);
        setDetails([]);

        if (!cardSelected?.subType) {
            const res = cardSelected
                ? await PaymentService.GetTotalsCardById(cashRegister?.id, cardSelected.id)
                : [];
            setDetails(mapTotals(res));
        } else
            setDetails(cardSelected.subType);

        setLoadingDetails(false);
    }

    const mapTotals = (totals) =>
        totals.reduce((total, curr) => ({
            ...total,
            [curr.subType]: {
                count: curr.count,
                total: curr.total,
                realTotal: cardSelected?.realTotal >= 0 ? cardSelected?.realTotal : '',
                realCount: cardSelected?.realCount >= 0 ? cardSelected?.realCount : '',
            }

        }), {
            ingressTotal: 0,
            egressTotal: 0,
            fullTotal: 0
        });

    const save = (ev, value, cardId) => {
        onAccept(value, cardId);
        setViewTotalModalOpen(false)
    }

    let diffTotals = 0;
    const calculateDiff = (totals) => {
        const refund = Number(totals?.subType?.Refund?.realTotal || 0) - Number(totals?.subType?.Refund?.total || 0);
        const voidSale = Number(totals?.subType?.Void?.realTotal || 0) - Number(totals?.subType?.Void?.total || 0);
        const sale = Number(totals?.subType?.Sale?.realTotal || 0) - Number(totals?.subType?.Sale?.total || 0);
        const diffValue = (sale + refund + voidSale);
        diffTotals += diffValue;
        setDiffCard(Math.abs(diffTotals));
        return diffValue;
    }

    return (
        <>
            <ViewTotal
                open={viewTotalModalOpen}
                details={details}
                onClose={() => setViewTotalModalOpen(false)}
                loading={loadingDetails}
                cardSelected={cardSelected}
                onAccept={save}
            />
            <Box component={Paper} padding={2}>
                <Grid container>
                    <Grid size={12}>
                        <Typography variant='h5'>
                            <strong>Tarjetas</strong>
                        </Typography>
                    </Grid>
                    <Grid size={12}>
                        <Info
                            color
                            highlight
                            ingress="Ingresos"
                            egress="Egresos"
                            total="Total"
                            diff="Diferencia"
                        />
                    </Grid>
                    {loadingCard && <Grid size={12}><Spinner /></Grid>}
                    {
                        cardsTotals &&
                        cardsTotals.cards?.map((card, i) => (
                            <Fragment key={`Total-${i}`}>
                                <Grid size={12}>
                                    <Total
                                        key={`card${i}`}
                                        totals={card}
                                        viewTotal={handleSetViewTotal}
                                        viewMovements={(cardId) => viewMovements({ cashTypeId: cardId, cashType: cashTypes.card })}
                                        diffValue={calculateDiff(card)}
                                    />
                                </Grid>
                                {
                                    cardsTotals.cards.length - 1 > i &&
                                    <Grid size={12}>
                                        <Divider light variant='middle' />
                                    </Grid>
                                }
                            </Fragment>
                        ))
                    }
                    <Grid size={12}>
                        <Divider />
                    </Grid>
                    <Grid size={12}>
                        <Info
                            highlight
                            description="Total:"
                            ingress={cardsTotals?.fullIngress || 0}
                            egress={cardsTotals?.fullEgress || 0}
                            total={cardsTotals?.fullTotal || 0}
                            diff={diffTotals || 0}
                            view=''
                        />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default ClosedCard;